<template>
  <v-content>
    <v-row no-gutters>
      <v-col cols="auto">
        <sidebar-menu-comp v-show="isNewDesign" />
      </v-col>
      <v-col>
        <div>
          <header-comp :headerConfig="headerConfig" v-show="!isNewDesign" />
          <subheader-nav-comp v-show="isNewDesign" />
          <div v-if="beginSessionTimer">
            <y-session-timer />
          </div>
          <y-toast-message />
          <v-container fluid class="contentCtr">
            <v-layout style="width:100%">
              <router-view></router-view>
            </v-layout>
          </v-container>
        </div>
      </v-col>
    </v-row>

    <v-snackbar
      v-model="toastMessage.show"
      top
      :color="toastMessage.color"
      :timeout="toastMessage.timeout"
    >{{ toastMessage.message }}</v-snackbar>
  </v-content>
</template>

<script>
import Header from '../../components/header.vue'
import Footer from '../../components/footer.vue'
import SideBarMenu from '../../components/sidebarMenu.vue'
import SubHeaderNav from '../../components/subheaderNavigation.vue'
import yToastMessage from '../../components/yToastMessage.vue'
import ySessionTimeoutPopup from '../../components/ySessionTimeoutPopup.vue'

export default {
  components: {
    'header-comp': Header,
    'sidebar-menu-comp': SideBarMenu,
    'subheader-nav-comp': SubHeaderNav,
    'y-toast-message': yToastMessage,
    'y-session-timer': ySessionTimeoutPopup
  },
  props: {},
  data() {
    return {}
  },
  computed: {
    isNewDesign() {
      return this.$store.state.appStore.isNewDesign
    },
    beginSessionTimer() {
      return this.$store.state.appStore.sessionManagement.beginSessionTimer
    },
    toastMessage() {
      return this.$store.state.appStore.toastMessage
    },
    headerConfig() {
      let config = {
        headerText: this.$lang.messages.sub_brand_management,
        showMenu: this.$store.state.appStore.showHeaderMenu,
        userName: this.$store.state.appStore.userInfo.userName
      }
      return config
    }
  }
}
</script>

<style>
.v-btn {
  text-transform: capitalize;
}
</style>
